import { render } from "./Header.vue?vue&type=template&id=c82b41ae&scoped=true"
import script from "./Header.ts?vue&type=script&lang=js"
export * from "./Header.ts?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=c82b41ae&scoped=true&lang=css"

import exportComponent from "/Users/r.hutter/Resilio Sync/_Workspace/git/TitleTool-NG/titletool-nextgen-server/titletool-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c82b41ae"]])

export default __exports__